import { z } from 'zod'

import { INVOICE_STATUS } from '../constants'

export const invoiceOverviewSchema = z.object({
  totalPaid: z.number(),
  nextPayment: z.number(),
  totalApplication: z.number(),
})

export type TInvoiceOverview = z.infer<typeof invoiceOverviewSchema>

export const invoiceStatusSchema = z.enum([INVOICE_STATUS.PAID, INVOICE_STATUS.NOT_PAY_YET])

export type TInvoiceStatus = z.infer<typeof invoiceStatusSchema>

export const invoiceFileSchema = z.object({
  id: z.string(),
  fileName: z.string(),
  filePath: z.string(),
  uploadedAt: z.string(),
})

export type TInvoiceFile = z.infer<typeof invoiceFileSchema>

export const invoiceDataSchema = z.object({
  id: z.number(),
  amount: z.number(),
  applicationId: z.number(),
  status: invoiceStatusSchema,
  applicationName: z.string(),
  paidAt: z.string().nullable(),
  invoiceFiles: z.array(invoiceFileSchema).optional(),
})

export type TInvoiceData = z.infer<typeof invoiceDataSchema>
